import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Box, Button, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { common } from '@mui/material/colors';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import jwtDecode from 'jwt-decode';
import { PassportAuth } from '../../contexts/AuthContext';
import { getStorage } from '../../utils/functions/localstorage';
import { useMediaQuery } from '@mui/material';
import { swalErrorTimer, swalSuccessTimer } from '../../helpers/swalHelper';
import CompanyApi from '../../service/company.api'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

export default function NavbarAdmin({
  openMobile,
  onMobileNavOpen,
  onMobileNavClose,
}) {
  const { handleAdminSignout } = useContext(PassportAuth);
  const onSignOut = async () => {
    await handleAdminSignout();
  };

  const [userName, setUserName] = useState(getStorage('username'));
  const [tokenCustomer, setTokenCustomer] = useState(getStorage('token'));

  const [isShowButtonUserLogin, setIsShowButtonUserLogin] = useState(false);

  const decoded = jwtDecode(tokenCustomer);
  const customerName = decoded.NAME;
  const customerTaxid = decoded.TAX_ID;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCopyUserLogin = async () => {
    try {
      const urlPath = await CompanyApi.getCompanyUrlPath()
      const path = window.location.origin
      const url = `${path}/${urlPath}`
      // Copy the link to the clipboard
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(url);
        swalSuccessTimer({title: 'ลิงก์ถูกคัดลอกสำเร็จ!'});
      } else {
        throw new Error('Clipboard API is not supported in this browser.');
      }
    } catch (error) {
      console.error('Error in copyTextToClipboard:', error);
      swalErrorTimer({text: `ไม่สามารถคัดลอกลิงก์ได้ กรุณาลองอีกครั้ง`});
    }
  }

  // Responsive mobile/ipad
  const isXsScreen = useMediaQuery('(max-width:600px)'); // เช็คหน้าจอขนาด xs
  const isLgScreen = useMediaQuery('(max-width:1000px)'); // เช็คหน้าจอขนาด xs

  useEffect(() => {
    const getSettingShowUserLogin = async () => {
      try {
        const isShowButtonUserLogin = await CompanyApi.getSettingShowUserLogin()

        setIsShowButtonUserLogin(Boolean(isShowButtonUserLogin))
      } catch (error) {
        console.error('Error in get setting button user login:', error);
      }
    }

    void getSettingShowUserLogin()
  }, [])

  return (
    <div>
      <Box sx={{ display: 'flex' }}>
        <AppBar
          position="fixed"
          sx={{
            height: '68px',
          }}
        >
          <div className="lg:hidden flex justify-between items-center py-1">
            <button style={{ marginLeft: '10px' }} className="cursor-pointer">
              <MenuIcon
                onClick={() => {
                  if (openMobile) {
                    onMobileNavClose();
                  } else {
                    onMobileNavOpen();
                  }
                }}
                fontSize="large"
                sx={{ color: common.white }}
              />
            </button>
            {/* <div className=" py-2 px-2 text-white uppercase">
              {customerName}
              <br />
               tax id : {customerTaxid}
            </div> */}
            {isXsScreen ? (
              <div className="uppercase py-2 px-2 text-white">
                {customerName.length > 20 ? customerName.slice(0, 20) + '...' : customerName}
              </div>
            ) : (
              <div className="uppercase py-2 px-2 text-white">
                {customerName}
              </div>
            )}
            <div className=" border-r-2 border-white" />
            <div className="py-2">
              <IconButton>
                <AccountCircleIcon sx={{ fontSize: 35, color: '#fff' }} />
              </IconButton>
              <IconButton
                aria-controls={open ? 'fade-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                <ArrowDropDownIcon sx={{ fontSize: 35, color: '#fff' }} />
              </IconButton>
              <IconButton>
                <Menu
                id="fade-menu"
                MenuListProps={{
                  'aria-labelledby': 'fade-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
              >
                {/* <MenuItem component={Link} to="/contact" onClick={handleClose}>
                  ติดต่อเรา
                </MenuItem> */}
                  { isShowButtonUserLogin && (
                    <MenuItem onClick={() => handleCopyUserLogin()}>
                      คัดลอกลิงก์ zzz
                    </MenuItem>
                    )
                  }
                <MenuItem
                  onClick={() => {
                    onSignOut();
                  }}
                >
                  ออกจากระบบ
                </MenuItem>
              </Menu>
              </IconButton>
            </div>
          </div>
          <div className="hidden md:flex justify-end items-center py-4 text-white">
            {isLgScreen ? (
              <div className=""></div>
            ) : (
              <div className="flex items-center justify-end gap-3 mx-5 flex-grow h-full">

                <div className="uppercase">Welcome, {customerName}</div>
                {
                  isShowButtonUserLogin && (
                    <Tooltip title="คัดลอกลิ้งค์ล็อคอินสำหรับ User" arrow>
                      <IconButton color="inherit" >
                        <ContentCopyOutlinedIcon
                          onClick={handleCopyUserLogin}
                        />
                      </IconButton>
                    </Tooltip>
                  )
                }
                <div className="">
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => {
                      handleAdminSignout();
                    }}
                  >
                    Logout
                  </Button>
                </div>
              </div>
            )}
          </div>
        </AppBar>
      </Box>
    </div>
  );
}
